import React from "react";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import CustomizationBorderRadiusRow, {
  BorderRadiusFieldEnum,
} from "../helpers/CustomizationBorderRadiusRow";

const ConfigurationModalBorderRadiusCard = () => {
  return (
    <ConfigurationSettingsCard title="Merge Link border radius">
      <div className="flex flex-col justify-between gap-4">
        <CustomizationBorderRadiusRow
          type={BorderRadiusFieldEnum.MODAL}
          label="Customize the border radius of the Merge Link modal"
        />
      </div>
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationModalBorderRadiusCard;
